export default "__VITE_ASSET__CofG467t__"